<template>
  <div class="p-casestudy-bg" :class="{'isWhite': isWhite}"></div>
</template>

<script>
  import gsap from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';
  gsap.registerPlugin(ScrollTrigger);

  export default {
    data() {
      return {
        isWhite: false,
        // styleBg: '',
      }
    },
    // computed: {
    //   setStyleBg: function() {
    //     return function() {
    //       return this.styleBg;
    //     }
    //   },
    // },
    created() {
    },
    mounted() {
      const domBody = document.querySelector('.p-casestudy__con');

      this.resize();
      window.addEventListener('resize', this.resize);

      ScrollTrigger.create({
        trigger: domBody,
        start: 'top top+=20%',
        end: 'bottom top+=20%',
        onEnter: () => {
          // console.log('onEnter');
          this.isWhite = true;
        },
        onLeaveBack: () => {
          // console.log('onLeaveBack');
          this.isWhite = false;
        },
        onLeave: () => {
          // console.log('onLeave');
          this.isWhite = false;
        },
        onEnterBack: () => {
          // console.log('onEnterBack');
          this.isWhite = true;
        }
      });
    },
    methods: {
      resize(e) {
      },
    }
  }
</script>
